import { LANGUAGE_CN } from '@home/_config/config';

import type { INewFeatureItem } from '@home/types/urlCollection';

const getNewFeatureLocaleText = (locale: string, textCN: string, textEN: string): string => {
  if (locale === LANGUAGE_CN) {
    return textCN || textEN;
  }

  return textEN || textCN;
};

export const getNewFeatureDisplayName = (locale: string, item: INewFeatureItem): string => {
  const pageNameEN = item?.page_name_en || '';
  const pageNameCN = item?.page_name_cn || '';

  return getNewFeatureLocaleText(locale, pageNameCN, pageNameEN);
};

export const getNewFeatureDisplayDescription = (locale: string, item: INewFeatureItem): string => {
  const pageDescEN = item?.description_en || '';
  const pageDescCN = item?.description_cn || '';

  return getNewFeatureLocaleText(locale, pageDescCN, pageDescEN);
};

export const getNewFeatureItemKey = (item: INewFeatureItem): string => {
  return [
    item?.id || '',
    item?.page_id || '',
    item?.redirect_path || '',
    item?.page_name_en || '',
    item?.page_name_cn || '',
    item?.online_time || '',
  ].join('__');
};
